import styled from 'styled-components';
import variables from '../style/variables';

const {
    screen_lg,
    screen_md,
    screen_sm
} = variables;

export const Container = styled.div`
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    max-width: 1140px;
    position: relative;
    
    ${props => props.hideXS && `
        @media(max-width: ${screen_sm}) {
            display: none;
        }
    `}
 
    @media(min-width: ${screen_sm}) {
        width: 750px;
    }
    @media(min-width: ${screen_md}) {
        width: 970px;
    }
    @media(min-width: ${screen_lg}) {
        width: 1170px;
    }
`;
export const Row = styled.div`
    &:before {
        display: table;
        content: " ";
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }
    &:after {
        display: table;
        content: " ";
        clear: both;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }
`;

export const MainEL = styled.main`
    ${props => (props.fixedHead) && `
        margin-top: 100px;

        @media(max-width: ${screen_md}) {
            margin-top: 150px;   
        }
    `}
    @media(max-width: ${screen_sm}) {
        margin-top: 51px;
    }
`;

export const BlogContainer = styled(Container)`
    min-height: calc(100vh - (60px + 374px));

    ${props => (props.fixedHead) && `
        margin-top: 100px;

        @media(max-width: ${screen_md}) {
            margin-top: 150px;   
        }
    `}
    @media(max-width: ${screen_sm}) {
        margin-top: 51px;
    }
`;


// WEBPACK FOOTER //
// ./src/components/style/global.jsx